import { render, staticRenderFns } from "./ServicePublicity.vue?vue&type=template&id=e95cfbf2&scoped=true&"
import script from "./ServicePublicity.vue?vue&type=script&lang=js&"
export * from "./ServicePublicity.vue?vue&type=script&lang=js&"
import style0 from "./ServicePublicity.vue?vue&type=style&index=0&id=e95cfbf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95cfbf2",
  null
  
)

export default component.exports